import { ChecklistItem } from '../../components/ChecklistItem';
import { SectionWrapper } from '../../components/SectionWrapper';

import styles from './HumanitiesCollaborationsSection.module.css';

const collaborations = [
  'History courses covering Western Civilization and global historical perspectives, UCLA',
  'Comparative Literature courses focused on writing, critical analysis, and close reading, UCLA',
  'AI-supported writing environments designed specifically for humanities students',
  'Custom textbooks and instructional materials developed in partnership with faculty',
  'Kai Coach, integrated into university coursework across History and Comparative Literature',
] as const;

export function HumanitiesCollaborationsSection() {
  return (
    <SectionWrapper background="white" data-testid="humanities-section-collaborations">
      <div className={styles.section}>
        <div className={styles.header}>
          <p className={styles.eyebrow}>RECENT COLLABORATIONS</p>
          <h2 className={styles.title}>Recent collaborations</h2>
        </div>

        <ul className={styles.list}>
          {collaborations.map((item) => (
            <ChecklistItem key={item}>{item}</ChecklistItem>
          ))}
        </ul>
      </div>
    </SectionWrapper>
  );
}
